export const AUTH_STORAGE = {
  TOKEN: 'obr_token',
  USER: 'obr_user',
  LOGOUT_REASON: 'obr_logout_reason',
} as const;

export const AUTH_EVENT = {
  LOGOUT: 'obr_auth_logout',
} as const;

export const AUTH_TIMEOUT = {
  INACTIVITY_MS: 10 * 60 * 1000,
  ACTIVITY_HEARTBEAT_MS: 60 * 1000,
} as const;

export const AUTH_ACTIVITY_EVENT = [
  'mousedown',
  'mousemove',
  'keydown',
  'scroll',
  'touchstart',
  'click',
] as const;

export type LogoutReason =
  | 'inactivity'
  | 'session_elsewhere'
  | 'user_inactive'
  | 'invalid_token'
  | 'no_token'
  | 'manual'
  | null;

export const AUTH_LOGOUT_REASON = {
  INACTIVITY: 'inactivity',
  SESSION_ELSEWHERE: 'session_elsewhere',
  USER_INACTIVE: 'user_inactive',
  INVALID_TOKEN: 'invalid_token',
  NO_TOKEN: 'no_token',
  MANUAL: 'manual',
} as const;

export const AUTH_REASON_MESSAGE: Record<string, string> = {
  inactivity: 'You were logged out due to 10 minutes of inactivity.',
  session_elsewhere: 'You were logged out because your account was logged in on another device.',
  user_inactive: 'Your account has been disabled. Please contact the admin.',
  invalid_token: 'Your session expired. Please sign in again.',
  no_token: 'Please sign in to continue.',
  manual: '',
};

export const CHANGE_PASSWORD_TEXT = {
  TITLE: 'Change Password',
  CURRENT_PASSWORD_LABEL: 'Current Password',
  NEW_PASSWORD_LABEL: 'New Password',
  CONFIRM_PASSWORD_LABEL: 'Confirm New Password',
  NEW_PASSWORD_HELPER: 'Minimum 6 characters',
  SUBMIT_BUTTON: 'Change Password',
} as const;

export const CHANGE_PASSWORD_MESSAGE = {
  PASSWORD_MISMATCH: 'New passwords do not match',
  PASSWORD_MIN_LENGTH: 'Password must be at least 6 characters',
  SUCCESS: 'Password changed. You will be logged out now.',
  FAILED: 'Failed to change password',
  CURRENT_PASSWORD_INCORRECT: 'Current password is incorrect',
} as const;

export const LOGIN_TEXT = {
  BRAND_NAME: 'Ocean Breeze Retreat',
  SUBTITLE: 'Sign in to continue',
  SUBMIT_BUTTON: 'Sign In',
  SHOW_PASSWORD: 'Show password',
  HIDE_PASSWORD: 'Hide password',
} as const;

export const LOGIN_FIELD_LABEL = {
  USERNAME: 'Username',
  PASSWORD: 'Password',
} as const;

export const LOGIN_MESSAGE = {
  FAILED: 'Login failed. Please try again.',
  INVALID_CREDENTIALS: 'Invalid username or password',
} as const;

export const LOGIN_TEST_ID = {
  USERNAME: 'login-username',
  PASSWORD: 'login-password',
} as const;
